export default __webpack_public_path__ + "static/media/head_icon.1ecf9d39.svg";